// extracted by mini-css-extract-plugin
export default {"dropdownMenu":"GlobalMessagingDropdownMenu_dropdownMenu__deYFR","dropdownPlaceholder":"GlobalMessagingDropdownMenu_dropdownPlaceholder__qZGQf"};